import React, { useEffect, useState } from "react";
import fetchData from "../../api/fetchApi";
import { useNavigate } from "react-router-dom";
import { Trash2, Edit } from "lucide-react";
import ConfirmDeleteModal from "../common/ConfirmDeleteModal";

export default function SlidersPage() {
  const [sliders, setSliders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigator = useNavigate();
  const [deleteId, setDeleteId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  useEffect(() => {
    const fetchSliders = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchData("chaat/sliders");
        setSliders(data.data || []);
      } catch (err) {
        setError(err.message || "حدث خطأ أثناء جلب البيانات");
      } finally {
        setLoading(false);
      }
    };
    fetchSliders();
  }, []);

  
  return (
  <div className="max-w-5xl mx-auto p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold">السلايدر</h2>
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow"
          onClick={
           ()=> navigator('/admin/sliders/new')
          }
        >
          إضافة سلايدر جديد
        </button>
      </div>
      {loading && <div className="text-gray-500">جاري التحميل...</div>}
      {error && <div className="text-red-600 mb-2">{error}</div>}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {sliders.map((slider) => (
          <div key={slider.id} className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4 flex flex-col gap-3 ">
            <img
              src={slider.image_path}
              alt={slider.name}
              className="w-full h-40 object-cover rounded-xl mb-2"
            />
            <div className="flex-1 flex flex-col gap-1 relative">
              <div className="absolute top-0 left-3 flex gap-2 z-10">
                <button
                  className="p-2 rounded-lg hover:bg-gray-100"
                  title="تعديل"
                  onClick={() => navigator(`/admin/sliders/${slider.id}/edit`)}
                >
                  <Edit size={18} className="text-blue-500" />
                </button>
                <button
                  className="p-2 rounded-lg hover:bg-gray-100"
                  title="حذف"
                  onClick={() => {
                    setDeleteId(slider.id);
                    setModalOpen(true);
                  }}
                >
                  <Trash2 size={18} className="text-gray-500" />
                </button>
              </div>
              <h3 className="font-semibold text-[#1D2035] text-lg">{slider.name}</h3>
              <div className="flex items-center gap-2 text-xs text-gray-400">
                <span>#{slider.id}</span>
                <span>الترتيب: {slider.order}</span>
                <span>النقرات: {slider.clicks}</span>
              </div>
              <div className="flex items-center gap-2 text-xs">
                <span className={slider.is_active ? "text-green-600" : "text-red-600"}>
                  {slider.is_active ? "نشط" : "غير نشط"}
                </span>
                <span className={slider.is_clickable ? "text-blue-600" : "text-gray-400"}>
                  {slider.is_clickable ? "قابل للنقر" : "غير قابل للنقر"}
                </span>
              </div>
              <a
                href={slider.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-700 underline text-xs mt-1"
              >
                {slider.link}
              </a>
              <p className="text-xs text-gray-400 mt-1">
                أضيف في: {slider.created_at ? new Date(slider.created_at).toLocaleString() : "-"}
              </p>
            </div>
          </div>
        ))}
      <ConfirmDeleteModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={async () => {
          if (!deleteId) return;
          try {
            await fetchData(`chaat/sliders/${deleteId}`, "DELETE");
            setSliders((prev) => prev.filter((s) => s.id !== deleteId));
            setModalOpen(false);
            setDeleteId(null);
          } catch (err) {
            alert(err.message || "فشل الحذف");
          }
        }}
      />
      </div>
      {(!loading && sliders.length === 0 && !error) && (
        <div className="text-gray-500 mt-4">لا توجد بيانات للسلايدر.</div>
      )}
    </div>
  );
}
